var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { DataStore } from '../../../../ts/helpers/DataStore';
import { Modal } from '../../../../ts/helpers/Modal';
import { FormFields } from '../../../../ts/components/FormFields';
const companyLabels = {
    'fr': {
        'yes': 'Nom de l’organisation',
        'no': 'Nom'
    },
    'de': {
        'yes': 'Name der Organisation',
        'no': 'Name'
    },
    'it': {
        'yes': 'Nome dell’organizzazione',
        'no': 'Nome'
    }
};
const notCompanyFieldsId = ['q_1', 'q_2', 'q_3', 'q_4', 'q_5', 'q_6', 'q_7', 'q_8', 'q_9', 'q_10', 'q_11', 'q_12', 'q_13', 'q_14', 'q_15', 'q_16', 'q_17', 'q_18', 'q_20', 'q_21', 'q_22', 'q_23', 'q_24', 'q_25'];
const notCompanyIds = ['section-company_size-title', 'section-company_size', 'section-financial_questions-title'];
export class Form extends Component {
    constructor(isDebugEnabled = false) {
        super('Form', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            yield DataStore.transfert();
            $(window).on('scroll', () => {
                if (window.pageYOffset > 90) {
                    $('#btn-back-to-top').removeClass('d-none');
                }
                else {
                    $('#btn-back-to-top').addClass('d-none');
                }
            });
            $('#btn-back-to-top').on('click', (event) => {
                event.preventDefault();
                $.scrollTo(0);
            });
            if ([0, 1, 2, 3, 4, 5].indexOf(parseInt($('.form').data('step'))) != -1) {
                this.mode = $('.form').data('mode');
                yield DataStore.init(this.mode);
                this.setupInterface();
                this.restorData();
                if (!Form.isComplete()) {
                    $('.btn-synthesis').addClass('disabled');
                }
                $('.quadrant-details img').on('mouseenter', (event, image) => {
                    image.parents('.quadrant-title').addClass('hover');
                }).on('mouseleave', (event, image) => {
                    image.parents('.quadrant-title').removeClass('hover');
                });
                $(window).on('scroll', () => {
                    Form.updateWheel();
                });
                $('#wheel #hover g').on('mouseenter', (event, group) => {
                    const dimension = group.attr('id');
                    $('#wheel #small, #wheel #large').addClass('d-none');
                    $('#wheel-container .title span').addClass('d-none');
                    $('#wheel-container .title #' + dimension).removeClass('d-none');
                }).on('mouseleave', (event, group) => {
                    $('#wheel-container .title span').addClass('d-none');
                    $('#wheel #small, #wheel #large').removeClass('d-none');
                    if ($('#wheel-container .title').data('restoreDimension')) {
                        console.log('restore', $('#wheel-container .title').data('restoreDimension'));
                        $('#wheel-container .title #dimension_' + $('#wheel-container .title').data('restoreDimension')).removeClass('d-none');
                    }
                });
                Form.updateCompletionCounters();
                Form.updateWheel();
            }
            else {
                $('.form').removeClass('disabled');
            }
            if ($('#please-scroll-to').length > 0) {
                const quadrant = parseInt($('#please-scroll-to').data('quadrant'));
                const target = $('.summary-block').length > 0 ? $('.summary-block[data-quadrant="' + quadrant + '"]') : $('.form h2').eq(quadrant - 1);
                const offset = $('.summary-block').length > 0 ? 10 : 30;
                const yPosition = target.position().y - $('.assessment-navigation').height() - offset;
                $.scrollTo(yPosition);
            }
            this.success();
        });
    }
    setupInterface() {
        // Setup the start button
        if ($('#btn-group-start').length > 0 && this.mode == 'local') {
            if (!DataStore.get().started) {
                $('#btn-form-start').removeClass('d-none').on('click', (event, button) => __awaiter(this, void 0, void 0, function* () {
                    event.preventDefault();
                    yield this.startNewForm();
                    window.location.href = button.attr('href');
                }));
            }
            else {
                $('#btn-form-reset').removeClass('d-none').on('click', (event, button) => __awaiter(this, void 0, void 0, function* () {
                    event.preventDefault();
                    button.addClass('loading');
                    yield Modal.show('confirm_new_form');
                    button.removeClass('loading');
                    const date = new Date();
                    date.setTime(DataStore.get('date'));
                    $('#existing-form-date').text(date.toLocaleDateString('fr-FR') + ' ' + date.getHours() + ':' + date.getMinutes());
                    $('#existing-form-company').html(DataStore.get('company') ? DataStore.get('company') : '&mdash;');
                    $('#btn-confirm-new-form').on('click', (event, modal_button) => __awaiter(this, void 0, void 0, function* () {
                        event.preventDefault();
                        modal_button.addClass('loading');
                        DataStore.clear();
                        yield this.startNewForm();
                        window.location.href = button.attr('href');
                    }));
                }));
                $('#btn-form-continue').removeClass('d-none');
            }
        }
        // Setup fields
        $('.form *[data-key]').on(['change', 'keyup'], (event, field) => {
            const key = $(field).data('key');
            field.parent().removeClass('empty');
            if (key != '')
                DataStore.update(key, field.val());
            if (key === 'company')
                $('.company-title-no-dash').text(field.val());
            Form.updateCompanyType();
        });
        $('.form .form-field-likert input').on(['change', 'click'], (event, radio) => {
            radio.parents('.form-field-likert').removeClass('empty');
            radio.parents('.form-field-likert').find('.form-check').removeClass('checked');
            radio.parent().addClass('checked');
            DataStore.update('answers', { id: radio.parents('.form-field-likert').data('answerId'), value: radio.val() }, true);
            Form.updateCompanyType();
            Form.manageLikertLabels();
            Form.updateCompletionCounters();
        });
        $('.form .form-field-likert .form-check').on('mouseenter', (event, field) => {
            //if (field.parents('.form-field-likert').find('input').length > 2) {
            //Form.updateCompanyType();
            //Form.manageLikertLabels();
            field.parents('.form-field-likert').find('label').removeClass('show').addClass('hide');
            field.find('label').addClass('show').removeClass('hide');
            /*if (parseInt(field.find('input').val()) == 1) {
              field.parents('.form-field-likert').find('input[value="2"]').prev().addClass('d-none');
            }
      
            if (parseInt(field.find('input').val()) == 2) {
              field.parents('.form-field-likert').find('input[value="1"]').prev().addClass('d-none');
              field.parents('.form-field-likert').find('input[value="3"]').prev().addClass('d-none');
            }
      
            if (parseInt(field.find('input').val()) == 3) {
              field.parents('.form-field-likert').find('input[value="2"]').prev().addClass('d-none');
              field.parents('.form-field-likert').find('input[value="4"]').prev().addClass('d-none');
            }
      
            if (parseInt(field.find('input').val()) == 4) {
              field.parents('.form-field-likert').find('input[value="3"]').prev().addClass('d-none');
            }*/
            //}
        }).on('mouseleave', (event, input) => {
            Form.updateCompanyType();
            Form.manageLikertLabels();
        });
        Form.updateCompanyType();
        Form.manageLikertLabels();
        // Setup navigation
        $('.form-navigation a').on('click', (event, button) => __awaiter(this, void 0, void 0, function* () {
            // Check if company name is empty
            if (!DataStore.get().company || DataStore.get().company === '') {
                event.preventDefault();
                button.addClass('loading');
                yield Modal.show('company_is_empty', () => {
                    const companyField = $('input[data-key="company"]');
                    setTimeout(() => {
                        $.scrollTo(companyField.parent().position().y - $('header').height() - 30);
                        companyField.get(0).focus();
                    }, 250);
                });
                button.removeClass('loading');
                return;
            }
            // Check if all answers are valid
            let count = 0;
            let completed = 0;
            $('.form *[data-key], .form-field-likert').each((field) => {
                if (field.hasClass('form-field-likert')) {
                    if (field.find('input:checked').length > 0)
                        completed++;
                    count++;
                }
                else {
                    if (!field.parent().hasClass('d-none')) {
                        if (field.val() !== '')
                            completed++;
                        if (Form.isCompany === 'yes' || (Form.isCompany === 'no' && !notCompanyFieldsId.includes(field.data('key'))))
                            count++;
                    }
                }
            });
            if (completed < count) {
                event.preventDefault();
                event.stopPropagation();
                let userWantToContinue = false;
                button.addClass('loading');
                yield Modal.show('has_empty_answers', () => {
                    if (userWantToContinue)
                        return;
                    this.highlightEmptyFields();
                    $.scrollTo($('.form .empty').first().position().y - $('header').height() - 130);
                });
                button.removeClass('loading');
                $('#btn-confirm-next').on('click', () => {
                    userWantToContinue = true;
                    window.location.href = button.attr('href');
                });
            }
        }));
        $('.form-action-end').on('click', (event, button) => __awaiter(this, void 0, void 0, function* () {
            if (!Form.isComplete()) {
                event.preventDefault();
                button.addClass('loading');
                yield Modal.show('form_not_completed');
                button.removeClass('loading');
                $('#btn-goto-overview').on('click', (event, button) => {
                    window.location.href = button.attr('href');
                });
            }
        }));
        $('.form').removeClass('disabled');
    }
    restorData() {
        Object.entries(DataStore.get()).forEach(([key, value]) => {
            if (key == 'answers') {
                Object.entries(value).forEach(([key, value]) => {
                    $('.form-field-likert[data-answer-id="' + key + '"] input[value="' + value + '"]').attr('checked', true).parent().addClass('checked');
                });
            }
            else {
                const field = $('.form *[data-key="' + key + '"]');
                if (field.length > 0) {
                    field.val(value);
                }
            }
        });
        Form.updateCompanyType();
        Form.manageLikertLabels();
        FormFields.update();
    }
    startNewForm() {
        return __awaiter(this, void 0, void 0, function* () {
            yield DataStore.update('started', true, true);
            yield DataStore.update('date', (new Date()).getTime(), true);
        });
    }
    static isComplete() {
        let questionCount = 0;
        let questionCompleted = 0;
        if (!DataStore.get())
            return;
        const isCompany = DataStore.get('is_company');
        Object.entries(DataStore.get()).forEach(([key, value]) => {
            if (isCompany === 'no' && notCompanyFieldsId.includes(key))
                return;
            if (['is_company', 'company'].includes(key)) {
                if (value && value !== '')
                    questionCompleted++;
                questionCount++;
            }
            if (key.search('q_') > -1) {
                if (key === 'q_2' || (key.match(/_/g) || []).length > 1)
                    return;
                if ($('[data-key="' + key + '"]').parent().hasClass('d-none'))
                    return;
                if (value != null && value !== '' || typeof value === 'number')
                    questionCompleted++;
                questionCount++;
            }
            if (key === 'answers') {
                Object.entries(value).forEach(([id, value]) => {
                    questionCompleted++;
                    questionCount++;
                });
            }
        });
        console.log(questionCompleted, questionCount);
        return questionCompleted >= questionCount;
    }
    highlightEmptyFields() {
        $('.form *[data-key]').each((field) => {
            if (field.val() === '')
                field.parent().addClass('empty');
        });
        $('.form-field-likert').each((field) => {
            if (field.find('input:checked').length === 0)
                field.addClass('empty');
        });
    }
    static manageLikertLabels() {
        $('.form .form-field-likert').each((field) => {
            field.find('label').removeClass('show hide');
            if (field.find('input').length > 2) {
                if (field.find('input:checked').length > 0) {
                    if ([1, 4].indexOf(parseInt(field.find('input:checked').val())) > -1) {
                        field.find('label').eq(1).removeClass('show');
                        field.find('label').eq(2).removeClass('show');
                    }
                    if (parseInt(field.find('input:checked').val()) == 2) {
                        field.find('label').eq(0).removeClass('show');
                        field.find('label').eq(2).removeClass('show');
                    }
                    if (parseInt(field.find('input:checked').val()) == 3) {
                        field.find('label').eq(1).removeClass('show');
                        field.find('label').eq(3).removeClass('show');
                    }
                }
                else {
                    field.find('label').eq(0).addClass('show');
                    field.find('label').eq(1).removeClass('show');
                    field.find('label').eq(2).removeClass('show');
                    field.find('label').eq(3).addClass('show');
                }
            }
            else if (field.find('input').length === 2 && field.find('input:checked').length === 0) {
                field.find('label').eq(0).addClass('show');
                field.find('label').eq(1).addClass('show');
            }
        });
    }
    static updateCompletionCounters() {
        $('.summary-block').each((block) => {
            let done = block.next().find('.form-field-likert input:checked').length;
            let total = block.next().find('.form-field-likert').length;
            if (done == total) {
                block.find('.question-done').parent().removeClass('text-red').addClass('text-primary');
            }
            else {
                block.find('.question-done').parent().removeClass('text-primary').addClass('text-red');
            }
            block.find('.question-done').text(done);
            block.find('.question-total').text(total);
        });
    }
    static updateWheel() {
        const currentDimension = parseInt($('#wheel-container').data('dimension'));
        let currentBlock = -1;
        $('.summary-block').each((block, index) => {
            if (currentBlock === -1 && block.viewportPosition().y > 110 && block.viewportPosition().y < $(window).height() - 100)
                currentBlock = index;
        });
        const currentQuadrant = (currentDimension - 1) * 3 + currentBlock + 1;
        console.log(currentDimension, currentBlock, currentQuadrant);
        if (currentBlock == -1) {
            $('#wheel-container .title #dimension_' + currentDimension).removeClass('d-none');
            $('#wheel-container .title').data('restoreDimension', currentDimension);
            $('#hover #dimension_' + currentDimension).css('opacity', 1);
        }
        else {
            $('#wheel #small path:not(#bg), #wheel #large path:not(#bg)').removeClass('active');
            for (let i = 1; i <= currentQuadrant - 1; i++) {
                $('#wheel #small_' + i).addClass('active');
            }
            $('#wheel #large_' + currentQuadrant).addClass('active');
        }
    }
    static updateCompanyType() {
        this.isCompany = DataStore.get('is_company');
        // Change company name label
        $('.form-control[data-key="company"]').prev().text(companyLabels[$('html').attr('lang').substring(0, 2)][this.isCompany]);
        // Hide irrelevant fields
        notCompanyFieldsId.forEach((fieldId) => {
            const parent = $(`*[data-key="${fieldId}"]`).parents('.form-field');
            if (this.isCompany === 'no') {
                parent.addClass('d-none-company');
            }
            else {
                parent.removeClass('d-none-company');
            }
        });
        // Hide irrelevant elements
        notCompanyIds.forEach((fieldId) => {
            const parent = $(`#${fieldId}`);
            if (this.isCompany === 'no') {
                parent.addClass('d-none-company');
            }
            else {
                parent.removeClass('d-none-company');
            }
        });
    }
}
